import SolutionCard from "../../reusables/SolutionCard";
import supply from "../../../assets/images/solutions-icon/ict_supply.svg";

const ICTSupplySolution = () => {
  return (
    <SolutionCard
      icon={supply}
      title="ICT Equipment Supply"
      subtitle="Reliable supply and installation of ICT hardware and software"
      ctaLink="/solutions/ict-equipment-supply"
    /> 
  );
};
 
export default ICTSupplySolution;